import axios from "axios";
import React, { useEffect } from "react";

import {
  FaFaceAngry,
  FaFaceFrown,
  FaFaceGrinWide,
  FaFaceMeh,
  FaFaceSmile,
  FaRegFaceAngry,
  FaRegFaceFrown,
  FaRegFaceGrinWide,
  FaRegFaceMeh,
  FaRegFaceSmile,
} from "react-icons/fa6";

const Form6 = ({ formData, setFormData, setCurrentStep, link }) => {
  const handleSubmit = (e) => {
    setCurrentStep(7);
    e.preventDefault();
    setTimeout(() => {
      window.scrollTo(0, window.innerHeight * 7);
      if (link) {
        axios.post(
          `https://feedback-git-main-feedback-services-projects.vercel.app/feedback?phone=${formData.phone}`,
          formData
        );
      } else axios.post("https://saboo-nexa.onrender.com/feedback", formData);
    }, 500);
  };

  useEffect(() => {
    if (
      formData.qualityOfWork !== "" &&
      formData.postServiceWashingAndCleaning !== ""
    ) {
      setCurrentStep(7);
      setTimeout(() => {
        window.scrollTo(0, window.innerHeight * 7);
        if (link) {
          axios.post(
            `https://feedback-git-main-feedback-services-projects.vercel.app/feedback?phone=${formData.phone}`,
            formData
          );
        } else axios.post("https://saboo-nexa.onrender.com/feedback", formData);
      }, 500);
    }
  }, [formData.qualityOfWork, formData.postServiceWashingAndCleaning]); // Removed handleSubmit from dependencies

  return (
    <div>
      <form
        onSubmit={handleSubmit}
        className="flex items-center justify-center h-screen px-2"
      >
        <div className="w-full max-w-xl md:max-w-3xl ">
          <p className="mb-2 text-lg font-bold text-center lg:mb-4 md:text-left">
            Quality of work performed
          </p>
          <div className="flex justify-center mt-4 mb-16 gap-x-2 lg:justify-start">
            <div
              className={`flex gap-5 mb-2 rounded-lg  border-2 md:w-1/5 bg-white ${formData.qualityOfWork === "Excellent"
                  ? " border-green-600 "
                  : " border-gray-200 "
                } `}
            >
              <label
                htmlFor="qualityOfWorkExcellent"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-6 h-6 text-xl text-green-600">
                  {formData.qualityOfWork !== "Excellent" ? (
                    <FaRegFaceGrinWide className="" />
                  ) : (
                    <FaFaceGrinWide className="" />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Excellent
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="qualityOfWorkExcellent"
                    className="w-1 h-1 max-w-2xl "
                    name="qualityOfWork"
                    value="Excellent"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        qualityOfWork: e.target.value,
                      });
                    }}
                  />
                </div>{" "}
              </label>
            </div>{" "}
            <div
              className={`flex gap-5 mb-2 rounded-lg  border-2 md:w-1/5 bg-white ${formData.qualityOfWork === "Very Good"
                  ? " border-[#89C442]"
                  : " border-gray-200 "
                } `}
            >
              <label
                htmlFor="qualityOfWorkVeryGood"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center text-xl text-[#89C442] justify-center w-6 h-6">
                  {formData.qualityOfWork !== "Very Good" ? (
                    <FaRegFaceSmile className="" />
                  ) : (
                    <FaFaceSmile className="" />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Very Good
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="qualityOfWorkVeryGood"
                    className="w-1 h-1 max-w-2xl "
                    name="qualityOfWork"
                    value="Very Good"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        qualityOfWork: e.target.value,
                      });
                    }}
                  />
                </div>{" "}
              </label>
            </div>
            <div
              className={`flex gap-5 mb-2 rounded-lg  border-2 md:w-1/5 bg-white ${formData.qualityOfWork === "Good"
                  ? " border-yellow-500"
                  : " border-gray-200 "
                } `}
            >
              <label
                htmlFor="qualityOfWorkGood"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-6 h-6 text-xl text-yellow-500">
                  {formData.qualityOfWork !== "Good" ? (
                    <FaRegFaceMeh className="" />
                  ) : (
                    <FaFaceMeh className="" />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Good
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="qualityOfWorkGood"
                    className="w-1 h-1 max-w-2xl "
                    name="qualityOfWork"
                    value="Good"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        qualityOfWork: e.target.value,
                      });
                    }}
                  />
                </div>{" "}
              </label>
            </div>
            <div
              className={`flex gap-5 mb-2 rounded-lg  border-2 md:w-1/5 bg-white ${formData.qualityOfWork === "Average"
                  ? " border-orange-600"
                  : " border-gray-200 "
                } `}
            >
              <label
                htmlFor="qualityOfWorkAverage"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-6 h-6 text-xl text-orange-600">
                  {formData.qualityOfWork !== "Average" ? (
                    <FaRegFaceFrown className="" />
                  ) : (
                    <FaFaceFrown className="" />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Average
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="qualityOfWorkAverage"
                    className="w-1 h-1 max-w-2xl "
                    name="qualityOfWork"
                    value="Average"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        qualityOfWork: e.target.value,
                      });
                    }}
                  />
                </div>{" "}
              </label>
            </div>
            <div
              className={`flex gap-5 mb-2 rounded-lg  border-2 md:w-1/5 bg-white ${formData.qualityOfWork === "Poor"
                  ? " border-red-600"
                  : " border-gray-200 "
                } `}
            >
              <label
                htmlFor="qualityOfWorkPoor"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-6 h-6 text-xl text-red-600">
                  {formData.qualityOfWork !== "Poor" ? (
                    <FaRegFaceAngry className="" />
                  ) : (
                    <FaFaceAngry className="" />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Poor
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="qualityOfWorkPoor"
                    className="w-1 h-1 max-w-2xl "
                    name="qualityOfWork"
                    value="Poor"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        qualityOfWork: e.target.value,
                      });
                    }}
                  />
                </div>{" "}
              </label>
            </div>
          </div>

          <p className="mt-6 mb-2 text-lg font-bold text-center md:mt-12 lg:mt-14 lg:mb-4 md:text-left">
            Washing & Cleanliness of the car post service
          </p>
          <div className="flex justify-center mt-4 mb-16 gap-x-2 lg:justify-start">
            <div
              className={`flex gap-5 mb-2 rounded-lg  border-2 md:w-1/5 bg-white ${formData.postServiceWashingAndCleaning === "Excellent"
                  ? " border-green-600 "
                  : " border-gray-200 "
                } `}
            >
              <label
                htmlFor="postServiceWashingAndCleaningExcellent"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-6 h-6 text-xl text-green-600">
                  {formData.postServiceWashingAndCleaning !== "Excellent" ? (
                    <FaRegFaceGrinWide className="" />
                  ) : (
                    <FaFaceGrinWide className="" />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Excellent
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="postServiceWashingAndCleaningExcellent"
                    className="w-1 h-1 max-w-2xl "
                    name="postServiceWashingAndCleaning"
                    value="Excellent"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        postServiceWashingAndCleaning: e.target.value,
                      });
                    }}
                  />
                </div>{" "}
              </label>
            </div>{" "}
            <div
              className={`flex gap-5 mb-2 rounded-lg  border-2 md:w-1/5 bg-white ${formData.postServiceWashingAndCleaning === "Very Good"
                  ? " border-[#89C442]"
                  : " border-gray-200 "
                } `}
            >
              <label
                htmlFor="postServiceWashingAndCleaningVeryGood"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-6 h-6 text-xl text-[#89C442]">
                  {formData.postServiceWashingAndCleaning !== "Very Good" ? (
                    <FaRegFaceSmile className="" />
                  ) : (
                    <FaFaceSmile className="" />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Very Good
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="postServiceWashingAndCleaningVeryGood"
                    className="w-1 h-1 max-w-2xl "
                    name="postServiceWashingAndCleaning"
                    value="Very Good"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        postServiceWashingAndCleaning: e.target.value,
                      });
                    }}
                  />
                </div>{" "}
              </label>
            </div>
            <div
              className={`flex gap-5 mb-2 rounded-lg  border-2 md:w-1/5 bg-white ${formData.postServiceWashingAndCleaning === "Good"
                  ? " border-yellow-500"
                  : " border-gray-200 "
                } `}
            >
              <label
                htmlFor="postServiceWashingAndCleaningGood"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-6 h-6 text-xl text-yellow-500">
                  {formData.postServiceWashingAndCleaning !== "Good" ? (
                    <FaRegFaceMeh className="" />
                  ) : (
                    <FaFaceMeh className="" />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Good
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="postServiceWashingAndCleaningGood"
                    className="w-1 h-1 max-w-2xl "
                    name="postServiceWashingAndCleaning"
                    value="Good"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        postServiceWashingAndCleaning: e.target.value,
                      });
                    }}
                  />
                </div>{" "}
              </label>
            </div>
            <div
              className={`flex gap-5 mb-2 rounded-lg  border-2 md:w-1/5 bg-white ${formData.postServiceWashingAndCleaning === "Average"
                  ? " border-orange-600"
                  : " border-gray-200 "
                } `}
            >
              <label
                htmlFor="postServiceWashingAndCleaningAverage"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-6 h-6 text-xl text-orange-600">
                  {formData.postServiceWashingAndCleaning !== "Average" ? (
                    <FaRegFaceFrown className="" />
                  ) : (
                    <FaFaceFrown className="" />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Average
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="postServiceWashingAndCleaningAverage"
                    className="w-1 h-1 max-w-2xl "
                    name="postServiceWashingAndCleaning"
                    value="Average"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        postServiceWashingAndCleaning: e.target.value,
                      });
                    }}
                  />
                </div>{" "}
              </label>
            </div>
            <div
              className={`flex gap-5 mb-2 rounded-lg  border-2 md:w-1/5 bg-white ${formData.postServiceWashingAndCleaning === "Poor"
                  ? " border-red-600"
                  : " border-gray-200 "
                } `}
            >
              <label
                htmlFor="postServiceWashingAndCleaningPoor"
                className="flex items-center w-full p-3 cursor-pointer"
              >
                <div className="flex items-center justify-center w-6 h-6 text-xl text-red-600">
                  {formData.postServiceWashingAndCleaning !== "Poor" ? (
                    <FaRegFaceAngry className="" />
                  ) : (
                    <FaFaceAngry className="" />
                  )}
                </div>
                <span className="hidden w-full ml-2 select-none md:block">
                  Poor
                </span>
                <div className="relative">
                  <div className="absolute top-0 left-0 w-2 h-full bg-white"></div>
                  <input
                    type="radio"
                    id="postServiceWashingAndCleaningPoor"
                    className="w-1 h-1 max-w-2xl "
                    name="postServiceWashingAndCleaning"
                    value="Poor"
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        postServiceWashingAndCleaning: e.target.value,
                      });
                    }}
                  />
                </div>{" "}
              </label>
            </div>
          </div>

          <div className="flex items-center justify-center gap-5 mt-10 lg:justify-end">
            {/* <p className="italic ">
              Press <span className="font-bold uppercase">Enter</span>
            </p> */}
            <button
              type="submit"
              className="px-6 py-3 font-bold text-white uppercase bg-gray-900 rounded-md whitespace-nowrap"
            >
              Next
            </button>
          </div>
        </div>{" "}
      </form>
    </div>
  );
};

export default Form6;
